module.exports = __webpack_public_path__ + "img/cleanup6-7-8-2021.241b0c31.jpg";